import React, { useEffect, useState } from "react";
import Restore from "../restore/Restore";
import SignIn from "../signIn/SignIn";
import SignUp from "../signUp/SignUp";
import Assign from "../assign/Assign";
import { useDispatch, useSelector } from "react-redux";
import { changeStepAction } from "../../redux/actions/actions";
import signOut from "../../functions";
import { LoginNavbar } from "./LoginNavbar";

export default function Login({
  signUpVideoGuide,
  paramsLogin,
  paramsPassword,
}) {
  const searchParams = new URLSearchParams(window.location.search);
  let paramsToken = searchParams.get("t");
  searchParams.get("p") ? "?p=" + searchParams.get("p") : "";
  // const [step, setStep] = useState(0);
  const { step } = useSelector((state) => state.error);
  const [currPage, setCurrpage] = useState("signIn");
  const urlPath = window.location.pathname;
  const dispatch = useDispatch();
  useEffect(() => {
    if (paramsToken) {
      if (urlPath === "/personal-studio/registration/") {
        setCurrpage("signUp");
        dispatch(changeStepAction(3));
        // setStep(3);
        signOut(dispatch);
      }
      if (urlPath === "/personal-studio/restore_password/") {
        setCurrpage("restore");
        dispatch(changeStepAction(3));
        // setStep(3);
      }
    }
  }, [paramsToken]);

  if (currPage === "restore") {
    return (
      <div style={{ position: 'relative' }}>
        <Restore
          setCurrpage={setCurrpage}
          step={step}
          paramsToken={paramsToken}
          signUpVideoGuide={signUpVideoGuide}
        />
        <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1000 }}>
            <LoginNavbar />
        </div>
      </div>
    );
  }

  if (currPage === "signUp") {
    return (
      <div style={{ position: 'relative' }}>
        <SignUp
          setCurrpage={setCurrpage}
          step={step}
          paramsToken={paramsToken}
          signUpVideoGuide={signUpVideoGuide}
        />
        <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1000 }}>
          <LoginNavbar />
        </div>
      </div>
    );
  }
  if (currPage === "assign") {
    return (
      <Assign setCurrpage={setCurrpage} signUpVideoGuide={signUpVideoGuide} />
    );
  }

  return (
  <div style={{ position: 'relative' }}>
    <SignIn
      setCurrpage={setCurrpage}
      signUpVideoGuide={signUpVideoGuide}
      paramsLogin={paramsLogin}
      paramsPassword={paramsPassword}
    />
    <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1000 }}>
      <LoginNavbar />
    </div>
  </div>
);
}
